export { ImageTextTile } from './ImageTextTile';
export { type ImageTextTileProps } from './types';
